import { Outlet, Link, NavLink, useLocation } from "react-router-dom";
//import jobqueuelayout from "./jobqueuelayout";


const LayoutNormal = () => {
	
const location = useLocation();
const boolHomeRoute= (location.pathname=='/' || location.pathname=='/login');
const independPath= (location.pathname=='/msme' || location.pathname=='/msmelogin');
console.log("inside LayoutNormal");

/*
const boolJobQueue= location.pathname=='/jobqueue' || location.pathname=='/cusworksheet' || location.pathname=='/pmtvouchers';
console.log("boolJobQueue "+boolJobQueue);
*/

function updatemenu() {
  if (document.getElementById('responsive-menu').checked == true) {
    document.getElementById('menu').style.borderBottomRightRadius = '0';
    document.getElementById('menu').style.borderBottomLeftRadius = '0';
  }else{
    document.getElementById('menu').style.borderRadius = '10px';
  }
}

return (
    <>
	{!boolHomeRoute && !independPath && <table align='center' width='95%' border='0' >
	<tbody>
	<tr>
			<td align='center' ><Link to="/dashboard" title="Go to Dashboard" ><img src='img/home.png' border='0' height='20' /></Link></td>
			<td align='center' >
			<span className='bannertextlarge'>Customs Apps</span>
			{/*
			<div className='bannertextsmall'>Ministry of Immigration and Border Services<br/>Turks and Caicos Islands Government</div>
			*/}
			
			</td>
			<td align='center' ><Link to="/logout" title={"logout "+sessionStorage.getItem("AW_USERNAME")} ><img src='img/exit.png' border='0' height='20'  /></Link></td>
	
	</tr>
	</tbody>
	</table>
	}
{/*
!boolHomeRoute && <nav id='menu'>
  <input type='checkbox' id='responsive-menu' onClick={(e)=>updatemenu()} /><label></label>
  <ul>
    
	
    
	<li><Link to="/sadfinder"  >declarations</Link></li>
	<li><Link to="/apps"  >vouchers</Link></li>
	<li><Link to="/inspact"  >inspection acts</Link></li>
	<li><Link to="/epustats"  >epu stats</Link></li>
    
	<li><a className='dropdown-arrow' href='http://'>settings</a>
      <ul className='sub-menus'>
        <li><Link to="/loginlog"  >login log</Link></li>
        <li><Link to="/transactions"  >transactions</Link></li>
      </ul>
    </li>
    
	<li><Link to="/logout"  >logout {sessionStorage.getItem("AW_USERNAME")}</Link></li>
	
  </ul>
</nav>
*/}

      {/*
	  Route index added in app.js to replace the below
	  boolHomeRoute && <jobque />
	  */}
      <Outlet />
    </>
  )
};

const LayoutJobqOld = () => {
	
console.log("inside LayoutJobq");

	return <table border="1" align="center" className="tblsidemenu"  >
  <tbody>
  <tr valign="top" >
  <td align="center" style={{background:"white", paddingTop:"48px" }} >
		<table align="center" border="0" >
		<tbody>
		<tr style={{height:"60px"}} ><td align="left" ><NavLink className="jobqbutton hide-menu nodecor" to={"/jobqueue"} state={{a:"1" }} ><span className="textwithimg" > Job Queue</span></NavLink></td></tr>
		<tr style={{height:"60px"}} ><td align="left" ><NavLink className="jobqbutton hide-menu nodecor" to={"/cusworksheet"} state={{a:"1" }} ><span className="textwithimg" > Customs Worksheet</span></NavLink></td></tr>
		<tr style={{height:"60px"}} ><td align="left" ><NavLink className="jobqbutton hide-menu nodecor" to={"/pmtvouchers"} state={{a:"1" }} ><span className="textwithimg" > Payment Vouchers</span></NavLink></td></tr>
		</tbody>
		</table>
  </td>
  <td align="center" >
  <Outlet />
  </td>
  </tr>
  </tbody>
  </table>;

};



export default LayoutNormal;